import React from "react";
import { Image, Text, View } from "react-native";
import { connect } from "react-redux";
import { setOnboardSeen } from "../../actions/user";
import { STYLES } from "../../assets/styles";
import Logo from "../../common/Logo";
import CustomButton from "../../components/CustomButton";

function OnBoarding({ setOnboardSeen }) {
  return (
    <View
      style={{
        flex: 1,
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <Image
        source={require("./../../assets/images/image4.jpg")}
        style={{ height: "100%", width: "100%", position: "absolute" }}
      />
      <View
        style={{
          height: "28%",
          width: "100%",
          elevation: 1,
          marginTop: "40%",
          padding: 25,
          justifyContent: "space-between",
        }}
      >
        <Logo color={STYLES.colors.white} />
        <Text
          style={{
            color: STYLES.colors.white,
            fontSize: STYLES.fontSizes.xxlarge,
            width: "80%",
          }}
        >
          Explore the new world of Clothing
        </Text>
      </View>
      <View
        style={{
          height: "10%",
          width: "100%",
          marginBottom: "5%",
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <CustomButton
          text="Lets Explore"
          rightIcon="arrow-right"
          btnStyle={{ borderRadius: 30 }}
          upppercase={false}
          onPress={setOnboardSeen}
        />
      </View>
    </View>
  );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  setOnboardSeen: () => dispatch(setOnboardSeen()),
});
export default connect(mapStateToProps, mapDispatchToProps)(OnBoarding);
